module.exports = __webpack_public_path__ + "img/jsnad-badge.86caf621.png";